/**
 * The running bundle's version.
 *
 * Extracted as a function rather than read inline so it can be unit-tested: `__APP_VERSION__` is
 * replaced at build time, so the only way to assert the wiring without a browser is to test the
 * thing that reads it.
 */
export function appVersion(): string {
    return __APP_VERSION__;
}
